// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"625":"2a7d6e44","948":"82f7607c"}[chunkId] + ".chunk.js";
};